export default "__VITE_ASSET__4cdf17b0__"